import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { SearchIcon } from "lucide-react";
import qs from "qs";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";

const SearchInput = ({
  className,
  label,
  readOnly,
  placeholder,
  type,
  size,
  field,
  disabled,
  isRequired,
  validate,
  value,
  prependData,
  inputClassName,
  handleSearch,
  ...props
}) => {
  const history = useHistory();
  const location = useLocation();

  const executeSearch = (searchValue) => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const newQuery = qs.stringify({
      ...query,
      search: searchValue,
      page: 1,
    });

    history.push({
      search: newQuery,
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      executeSearch(value);
    }
  };

  const classes = cx(
    "form-field",
    `form-field--${size}`,
    disabled && `form-field--disabled`,
    value && "form-field--active",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <label className="form-field__label">
          {label}
          {isRequired && <span title={"Обязательный поля"}>*</span>}
        </label>
      )}
      <div className="search-group">
        <input
          className={`search-group__input ${inputClassName}`}
          readOnly={readOnly}
          disabled={disabled}
          value={value}
          onKeyDown={handleKeyDown}
          {...{ placeholder, type }}
          {...props}
        />
        <button
          type="button"
          className="search-group-btn"
          onClick={() => executeSearch(value)}
        >
          <SearchIcon width={20} height={20} />
        </button>
      </div>
    </div>
  );
};

SearchInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(["text", "password", "number"]),
  className: PropTypes.string,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(["default", "large", "small"]),
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  handleSearch: PropTypes.func,
};

SearchInput.defaultProps = {
  label: "",
  placeholder: "",
  inputClassName: "",
  type: "text",
  className: null,
  readOnly: false,
  disabled: false,
  isRequired: false,
  size: "default",
  handleSearch: () => {},
};

export default SearchInput;
